import { render, staticRenderFns } from "./offerDetail.vue?vue&type=template&id=b0d51c1a&scoped=true"
import script from "./offerDetail.vue?vue&type=script&lang=js"
export * from "./offerDetail.vue?vue&type=script&lang=js"
import style0 from "./offerDetail.vue?vue&type=style&index=0&id=b0d51c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d51c1a",
  null
  
)

export default component.exports